module.exports = __webpack_public_path__ + "static/media/GIF2.d215f615.mp4";